import React from 'react';

import type { RouteObject } from 'react-router-dom';

import Pages from '@/pages';

const WorkingPeriodsView = React.lazy(
  () => import('@/pages/WorkingPeriods/views/WorkingPeriodsView'),
);
const WorkingPeriodSubsystems = React.lazy(
  () => import('@/pages/WorkingPeriods/views/WorkingPeriodSubsystems'),
);

export const workingPeriodsRoutes: RouteObject[] = [
  {
    element: <WorkingPeriodsView />,
    index: true,
  },
  {
    path: Pages.SUBSYSTEMS,
    element: <WorkingPeriodSubsystems />,
  },
];
